/**
 * Frontend logger
 * - Silent in production by default
 * - Enable in production by setting REACT_APP_ENABLE_FRONTEND_LOGS=true at build time
 * - Always redacts common sensitive fields (password/token/authorization) from any logged objects
 */
const ENABLED =
  process.env.NODE_ENV !== 'production' ||
  String(process.env.REACT_APP_ENABLE_FRONTEND_LOGS || '').toLowerCase() === 'true';

const SENSITIVE_KEYS = new Set([
  'password',
  'pass',
  'pwd',
  'token',
  'access_token',
  'refresh_token',
  'authorization',
  'auth',
  'jwt',
]);

function redactValue(key, value) {
  if (SENSITIVE_KEYS.has(String(key || '').toLowerCase())) return '[REDACTED]';
  return value;
}

function redact(input, depth = 0) {
  if (depth > 4) return '[TRUNCATED]';
  if (input == null) return input;
  if (typeof input === 'string') return input;
  if (typeof input !== 'object') return input;

  if (Array.isArray(input)) return input.map((v) => redact(v, depth + 1));

  const out = {};
  for (const [k, v] of Object.entries(input)) {
    out[k] = redact(redactValue(k, v), depth + 1);
  }
  return out;
}

function fmtArgs(args) {
  return args.map((a) => redact(a));
}

export const logger = {
  enabled: ENABLED,
  debug: (...args) => {
    if (!ENABLED) return;
    // eslint-disable-next-line no-console
    console.debug(...fmtArgs(args));
  },
  info: (...args) => {
    if (!ENABLED) return;
    // eslint-disable-next-line no-console
    console.info(...fmtArgs(args));
  },
  warn: (...args) => {
    if (!ENABLED) return;
    // eslint-disable-next-line no-console
    console.warn(...fmtArgs(args));
  },
  error: (...args) => {
    if (!ENABLED) return;
    // eslint-disable-next-line no-console
    console.error(...fmtArgs(args));
  },
};


